import { OnInit, OnDestroy, Component, ElementRef, Input } from '@angular/core';
import { LabelData } from 'src/app/data/configurator/label/label.data';
import { Subscription } from 'rxjs';
import { LabelEvent } from 'src/app/events/label.event';

declare const fabric: any;

@Component({
  selector: 'label-preview',
  template: ``,
  host: {
    class: 'label-preview'
  }
})
export class LabelPreview implements OnInit, OnDestroy {

  private _preview: HTMLCanvasElement;
  private _previewStage: any;

  protected _labelData: LabelData;
  protected _labelSubscription: Subscription;

  private _redrawTimeout: any;

  @Input() set label(data: LabelData) {
    this._labelData = data;
    this.redraw();
    this._labelSubscription = data.onChange.subscribe({
      next: (event: LabelEvent) => {

        // console.log("LabelPreview.LabelData.onChange()");
        if (this._redrawTimeout) {
          clearTimeout(this._redrawTimeout);
        }
        this._redrawTimeout = setTimeout(() => {
          this._redrawTimeout = null;
          this.redraw();
        }, 500);

      }
    });
  }

  @Input() public set ratio(value: number) {
    this._ratio = value;
    this.redraw();
  }
  public get ratio(): number {
    return this._ratio;
  }
  private _ratio: number = -1;

  private _border:any;
  private _mask:any;
  private _masker:any;

  /**
	 * Constructor
	 */
  constructor(private elementRef: ElementRef) {
    this._preview = document.createElement("canvas");
    this._previewStage = new fabric.StaticCanvas(this._preview);

    this.elementRef.nativeElement.appendChild(this._preview);

  }

  getLabel():Promise<void>{
    return new Promise((resolve, reject)=>{

      if(!this._border){

        fabric.loadSVGFromString(this._labelData.templateData.svg, (objects, options) => {

          this._border = fabric.util.object.clone(objects[0]);
          this._border.set({
            evented: false,
            fill: 'transparent',
            stroke: '#AAAAAA',
            strokeWidth:1
          });
          this._mask = fabric.util.object.clone(objects[1]);
          this._mask.set({
            evented: false,
            left:objects[0].width*-.5,
            top:objects[0].height*-.5
          });
          this._mask.inverted = true;
          this._masker = new fabric.Rect({
              evented: false,
              clipPath: this._mask,
              width: objects[0].width,
              height: objects[0].height,
              fill: 'white',
            });
        });
        resolve();
      } else {
        resolve();
      }

    });
  }

	/**
	 * On init
	 */
  ngOnInit() {

  }

  /**
   * Redraw
   */
  redraw() {

    // console.log("LabelPreview.redraw()");

    if (this.ratio != -1 && this._labelData) {

      this._previewStage.setWidth(Math.round(this._labelData.label.previewStage.getWidth() * this.ratio+1));
      this._previewStage.setHeight(Math.round(this._labelData.label.previewStage.getHeight() * this.ratio+1));
      this._previewStage.setZoom(this._labelData.label.previewStage.getZoom() * this.ratio);
      this._previewStage.loadFromJSON(JSON.stringify(this._labelData.label.previewStage), () => {
        this.getLabel().then(()=>{
          this._border.set({
            width: this._labelData.label.previewStage.getWidth(),
            height: this._labelData.label.previewStage.getHeight(),
            strokeWidth:1 / this.ratio,
            top:0,
            left:0,
          });
          // this._mask.set({
          //   width: this._labelData.label.previewStage.getWidth(),
          //   height: this._labelData.label.previewStage.getHeight(),
          //   top:-0.5*this._labelData.label.previewStage.getHeight(),
          //   left:-0.5*this._labelData.label.previewStage.getWidth(),
          // });

          // let _masker = new fabric.Rect({
          //   evented: false,
          //   clipPath: this._mask,
          //   width: this._labelData.label.previewStage.getWidth(),
          //   height: this._labelData.label.previewStage.getHeight(),
          //   fill: 'white',
          // });

          this._masker.set({
            width: this._labelData.label.previewStage.getWidth()+1/ this.ratio,
            height: this._labelData.label.previewStage.getHeight()+1/ this.ratio
          });

          this._previewStage.add(this._masker);
          this._previewStage.add(this._border);
          this._previewStage.renderAll();
        });

      });
    }
  }

	/**
	* On destroy
	*/
  ngOnDestroy() {
    if (this._redrawTimeout) {
      clearTimeout(this._redrawTimeout);
    }
    if (this._previewStage) {
      try {
        this._previewStage.dispose();
      } catch (error) {

      }
      this._previewStage = null;
    }

    if (this._labelSubscription) {
      this._labelSubscription.unsubscribe();
      this._labelSubscription = null;
    }
  }
}
